import { useLocation } from 'react-router';
import { RefObject, useEffect } from 'react';
import { useStableFunction } from './use-stable-function';

// Offset the scroll position to ensure compatibility with browsers like Safari,
// which may not scroll to the exact top without an adjustment
const BROWSER_SCROLL_OFFSET = -100;

const useResetPageScroll = (containerRef?: RefObject<HTMLElement | null>) => {
  const { pathname } = useLocation();
  const scrollToTop = useStableFunction(() => {
    const container = containerRef?.current || window;
    container.scroll(0, BROWSER_SCROLL_OFFSET);
  });

  useEffect(
    function resetPageScroll() {
      scrollToTop();
    },
    [pathname, scrollToTop],
  );
};

export default useResetPageScroll;
